/*  ========================================================================
    # Hooks - Use Localization
    ========================================================================  */

export default function useLocalization() {
  const localization = window.jsLocalize || {};
  return key => localization[key] || '';
}
